import { AppState } from '@/app/State/AppState';
import { selectIsPrivateAccess, selectTenantProfile } from '@/app/State/Tenant/tenant.selector';
import { Roles } from '@/app/core/Models/Roles';
import { Tenant } from '@/app/core/Models/tenant';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
  Route,
  UrlSegment,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, first, map, of, from } from 'rxjs';
import { LoginWithTokensUseCase } from '@/app/core/usecases/Auth/LoginWithTokensUseCase';

@Injectable()
export class OnboardingGuard
  implements CanActivate {
  constructor(
    private store$: Store<AppState>,
    private router: Router,
    private loginWithTokenUseCase: LoginWithTokensUseCase
  ) { }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    
    // Check if this is the auth/login/{token} route
    if (state.url.startsWith('/auth/login_with_token')) {
      const token = route.paramMap.get('token');
      const refreshToken = route.paramMap.get('refreshToken');
      console.log('token', token)
      console.log('refreshToken', refreshToken)
      if (token && refreshToken) {
        // Convert Promise to Observable using from()
        return from(this.loginWithTokenUseCase.execute({ yib_tk: token, yib_rt: refreshToken })).pipe(
          map(() => {
            console.log('Login successful, redirecting to signup');
            return this.router.parseUrl('/auth/signup');
          })
        );
      }
    }
    
    // this.store$.dispatch(GrantUserStartAction())
    return combineLatest([
      this.store$.select(selectTenantProfile).pipe(first(x => !!x)),
      this.store$.select(selectIsPrivateAccess),
      // this.store$.select(selectCurrentPaymentMethod).pipe(first((x): x is PaymentMethod => !!x)),
    ]).pipe(
      map(([profile, privateAccess]) => {
        const granted = this.grantAccess(profile, privateAccess);
        !granted && this.router.navigateByUrl('getting-started');
        // this.store$.dispatch(GrantUserEndAction())
        return granted
      })
    )
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    
    // Reconstruct URL from segments
    const url = '/' + segments.map(segment => segment.path).join('/');
    
    if (url.startsWith('auth/login_with_token')) {
      // This shouldn't happen now as we're handling it in the component
      return true;
    }
    
    // this.store$.dispatch(GrantUserStartAction())
    return combineLatest([
      this.store$.select(selectTenantProfile).pipe(first(x => !!x)),
      this.store$.select(selectIsPrivateAccess),
      // this.store$.select(selectCurrentPaymentMethod).pipe(first((x): x is PaymentMethod => !!x)),
    ]).pipe(
      map(([profile, privateAccess]) => {
        const granted = this.grantAccess(profile, privateAccess);
        if (!granted) {
          // this.store$.dispatch(GrantUserEndAction())
          return this.router.parseUrl('/getting-started');
        }
        // this.store$.dispatch(GrantUserEndAction())
        return granted;
      })
    );
  }

  grantAccess(profile: Tenant | undefined, privateAccess: boolean | undefined) {
    const newOnboardingDate = new Date('02/28/2024')
    // const questionnaireDate = new Date('05/16/2024')
    // return !!privateAccess
    //   || isNaN(Date.parse(profile!.tenant_created_dt as any))
    //   || (profile!.tenant_created_dt < newOnboardingDate)
    //   || profile!.roles.includes(Roles.user)
    //   // || (
    //     // !!profile?.account.is_updated
    //     // && profile.account.phone.validation 
    //     // && profile.VOICE_ONBOARDING_COMPLETED 
    //     // && (!!profile?.onboarding_questions_answered || profile!.tenant_created_dt < questionnaireDate)
    //   // );
    return true
  }
}
